import { Navigate, Outlet, createBrowserRouter, useRouteError } from 'react-router-dom';
import { EventDateReport, EventStatsContainer } from './screens';
import { useTranslation } from 'react-i18next';
import Navigation from './ReportsNavigation';
import LoginResponse from './screens/LoginResponse';
import EventList from './screens/events/EventList';

const RouterComponent = () => {
	var ErrorElement = () => {
		var { t } = useTranslation();
		const error = (useRouteError() as any);
		return <div>
			<div className="fr centered header" style={{ fontSize: 100 }}>
				{error.status}
				<div className="sub header" style={{ fontSize: 20 }}>
					{error.status === 404 ? t('notfound.message') : t('common.unexpected_error')}
				</div>
			</div>
		</div>
	}

	const Router = createBrowserRouter([{
		path: '/auth',
		element: <LoginResponse />
	}, {
		path: '/',
		errorElement: <Navigation outlet={<ErrorElement />} />,
		element: <Navigation outlet={<Outlet />} />,
		children: [
			{ path: '/', element: <EventList /> },
			// { path: '/auth', element: <Navigate to={'/'} /> },
			{ path: '/miseventos/:event_id', element: <EventStatsContainer /> },
			{ path: '/miseventos/:event_id/funciones/:date_id', element: <EventStatsContainer /> },
			{ path: '/miseventos/:event_id/funciones/:date_id/*', element: <EventStatsContainer /> },
			{ path: '/miseventos/:event_id/*', element: <EventStatsContainer /> },
			// { path: '/events/:event_id/date/:date_id', element: <EventDateReport /> },
			// { path: '/events/:event_id/date/:date_id/access', element: <EventDateAccess /> },
		]
	}]);

	return Router;
}

export default RouterComponent;